<div class="m-333">
  <div *ngFor="let example of examples" class="mb-24">
    <egret-example-viewer [exampleId]="example" [path]="componentDirPath" [data]="exampleComponents[example]"></egret-example-viewer>
  </div>
</div>